// extracted by mini-css-extract-plugin
export default {"rollbackButton":"RollbackButton_rollbackButton__eoL7Z"};